import { Pipe, PipeTransform } from '@angular/core';
import { currenciesNoDp } from 'libs/shared/utils/src/format-price/transform-to-current-currency.util';

@Pipe({
  name: 'customCurrency',
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: string, currency: string): string {
    if (!value) {
      return value;
    }

    // Remove leading zeros
    value = value.replace(/^0+(?!\.|$)/, '');

    // Determine if the currency should have decimal places
    const hasDecimalPlaces = !currenciesNoDp.includes(currency);

    // If value starts with a decimal point, prepend a "0"
    if (value.startsWith('.')) {
      value = '0' + value;
    }

    // Split the value into integer and fractional parts
    const [integerPart, fractionalPart = ''] = value.split('.');

    // Add commas to the integer part
    const formattedIntegerPart = integerPart.replace(/\d(?=(\d{3})+$)/g, '$&,');

    if (hasDecimalPlaces) {
      // Ensure the fractional part has exactly two digits
      const formattedFractionalPart = fractionalPart.padEnd(2, '0').substring(0, 2);
      return `${formattedIntegerPart}.${formattedFractionalPart}`;
    } else {
      // For currencies without decimal places, ignore any fractional part
      return formattedIntegerPart;
    }
  }
}
